import { BannerWrapper } from "../BannerWrapper";
import { BannerWrapperV2 } from "../BannerWrapperV2";
import { SkeletonBlock } from "@zapier/design-system";
import { isAiPageAtom } from "@zapier/canvas-state";
import { useAtomValue } from "jotai";

type ProgressBannerProps = {
  title?: string;
  description?: string;
};

export function ProgressBanner({
  title = "Building your system",
  description = "Generating the assets for your canvas",
}: ProgressBannerProps) {
  const isAiPage = useAtomValue(isAiPageAtom);

  if (isAiPage) {
    return <ProgressBannerAiPage />;
  }

  return <ProgressBannerNewPage title={title} description={description} />;
}

export function ProgressBannerNewPage({
  title = "Building your system",
  description = "Generating the assets for your canvas",
}: ProgressBannerProps) {
  return (
    <BannerWrapper title={title} description={description} showProgress={true}>
      <SkeletonBlock color="GrayWarm3" width="91px" height="36px" />
      <SkeletonBlock color="GrayWarm3" width="152px" height="36px" />
      <SkeletonBlock color="GrayWarm3" width="133px" height="36px" />
    </BannerWrapper>
  );
}

export function ProgressBannerAiPage() {
  return (
    <BannerWrapperV2 showProgress={true}>
      <div />
      <div>
        <SkeletonBlock color="GrayWarm3" width="152px" height="36px" />
        <SkeletonBlock color="GrayWarm3" width="133px" height="36px" />
      </div>
    </BannerWrapperV2>
  );
}
